import Config from 'react-native-config';
import { Platform } from 'react-native';
import StyleSheet from 'react-native-media-query';
import colors from '../../theme/Colors';
import size from '../../theme/Fonts';
import { isDesktop, isIOS, isWeb } from '../../utils/BooleanUtility';
import { getScreenHeight, getScreenWidth } from '../../utils/LayoutUtility';

export const { ids, styles } = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    width: getScreenWidth(),
    alignSelf: 'center',
  },
  headerContainerWeb: {
    padding: 12,
    paddingRight: 0,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 10,
  },
  activityContainer: {
    paddingLeft: 12,
    justifyContent: 'flex-end',
    width: '100%',
  },
  cardContainer: {
    width: getScreenWidth() - 58,
    alignSelf: 'flex-end',
    paddingHorizontal: 12,
    paddingVertical: 12,
  },
  gradient: {
    borderRadius: 16,
  },
  actionButtonContainer: {
    height: 40,
    width: '100%',
    alignSelf: 'center',
    backgroundColor: 'transparent',
    marginTop: 12,
  },
  actionButton: {
    left: 12,
    right: 12,
    bottom: 14,
    height: 40,
    borderRadius: 8,
  },
  actionButtonText: {
    color: colors.white,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
  },
  actionButtonIcon: {
    width: 18,
    height: 18,
    tintColor: colors.white,
    resizeMode: 'contain',
    marginRight: 4,
  },
  headerContainer: {
    padding: 12,
    paddingRight: 0,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: isIOS() ? 56 : 46,
  },
  headerTitle: {
    color: colors.foxyBlack,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
    flex: 1,
  },
  headerIcon: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
  },
  headerIconContainer: {
    height: 32,
    width: 32,
    borderRadius: 16,
    backgroundColor: colors.white,
    marginRight: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  activityCardHeaderContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    paddingTop: 12,
    paddingHorizontal: 12,
  },
  activityCardTitleContainer: {
    flex: 1,
  },
  activityCardTitle: {
    color: colors.black,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h1,
  },
  activityCardHeaderIcon: {
    width: 32,
    height: 32,
    marginRight: 12,
    resizeMode: 'contain',
  },
  subtitle: {
    color: colors.foxyBlack,
    fontSize: size.h4,
    fontFamily: 'Roboto-Regular',
    marginTop: 4,
  },
  point: {
    color: colors.subtitle,
    width: 4,
    height: 4,
  },
  playIcon: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
  },
  divider: {
    backgroundColor: colors.white,
    height: 1,
    marginVertical: 12,
    marginHorizontal: 12,
  },
  routineItemContainer: {
    marginLeft: 52,
    marginRight: 12,
  },
  verticalLine: {
    width: 1,
    flex: 1,
    backgroundColor: colors.divider,
  },
  verticalLineGreen: {
    width: 1,
    backgroundColor: colors.green,
    zIndex: 1,
    top: 0,
    position: 'absolute',
  },
  timelineText: {
    color: colors.black,
    fontFamily: 'Roboto-Regular',
    fontSize: size.h3_5,
    marginBottom: 4,
    backgroundColor: colors.background,
  },
  timelineTextPlaceholder: {
    height: 16,
    width: 32,
    borderRadius: 8,
  },
  timelineContainer: {
    position: 'absolute',
    top: 0,
    left: 8,
    height: '100%',
    width: 58,
    alignItems: 'center',
  },
  routineActivityContainer: {
    marginBottom: 22,
    marginTop: 4,
  },
  placeholderTitle: {
    width: 100,
    height: 20,
    alignSelf: 'center',
    borderRadius: 4,
  },
  placeholderListItem: {
    height: 60,
    width: 37,
    marginVertical: 20,
    marginHorizontal: 12,
    borderRadius: 20,
  },
  toast: {
    position: 'absolute',
    bottom: 0,
    maxWidth: getScreenWidth() - 32,
  },
  dashedBorder: {
    alignSelf: 'center',
    width: '60%',
    height: 1,
    borderWidth: 1,
    borderRadius: 2,
    borderColor: colors.foxyBlack,
    borderStyle: 'dashed',
  },
  borderMaskContainer: {
    top: 0,
    width: '100%',
    height: 1,
    backgroundColor: colors.white,
    zIndex: 2,
  },
  borderMask: {
    flex: 1,
    backgroundColor: colors.routine_green_bg,
  },
  upcoming: {
    color: colors.foxyBlack,
    fontFamily: 'Roboto-Bold',
    fontSize: 24,
    flex: 1,
    paddingHorizontal: 8,
    marginTop: -8,
    backgroundColor: colors.background,
  },
  upcomingTitleContainer: {
    position: 'absolute',
    zIndex: 1,
  },
  upcomingHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 12,
    marginTop: 18,
    marginBottom: 16,
  },
  offerRailHeading: {
    color: colors.black,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h1,
    marginBottom: 8,
    marginTop: 12,
    marginLeft: 16,
  },
  offerFlatlist: {
    marginBottom: 12,
  },
  progressFeatureRailContainer: {
    paddingHorizontal: 6,
    marginVertical: 8,
  },
  toastStyle: {
    position: 'absolute',
    bottom: 70,
  },
  subscribeRouteContainer: {
    width: getScreenWidth(),
    alignSelf: 'center',
  },
  tag: {
    flexDirection: 'row',
    paddingVertical: 4,
    borderRadius: 12,
    margin: 4,
    paddingHorizontal: 12,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.white,
  },
  tagsContainer: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: 12,
  },
  tagIcon: { height: 14, width: 14, marginRight: 8 },
  tagText: {
    fontFamily: 'Roboto',
    fontSize: size.h3_5,
    color: Config.THEME_COLOR || colors.green,
  },
  backgroundImage: {
    width: getScreenWidth(),
    height: getScreenWidth(),
    resizeMode: 'contain',
  },
  desktopBackgroundImage: {
    width: getScreenWidth(),
    height: getScreenHeight() / 2,
    resizeMode: 'contain',
  },
  listContainer: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: getScreenWidth(),
    marginTop: isWeb() ? 0 : getScreenWidth() - 30,
    paddingBottom: 70,
    '@media (min-width: 768px)': {
      marginTop: 0,
    },
  },
  background: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingHorizontal: 12,
    paddingTop: 12,
    height: '100%',
    backgroundColor: colors.background,
  },
  backgroundUnsubscribed: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingHorizontal: 12,
    paddingBottom: 12,
    paddingTop: 12,
    height: '100%',
    backgroundColor: colors.background,
  },
  scrollView: {
    height: getScreenHeight() - (isIOS() ? 0 : 12),
    zIndex: 1,
    ...Platform.select({
      web: {},
      default: {
        position: 'absolute',
      },
    }),
  },
  header: {
    position: 'absolute',
    top: 0,
  },
  title: {
    color: colors.foxyBlack,
    fontFamily: 'Roboto-Bold',
    alignSelf: 'center',
    fontSize: 24,
    marginBottom: 12,
  },
  subscriptionContainer: {
    bottom: 0,
    zIndex: 2,
    backgroundColor: colors.white,
    paddingHorizontal: 12,
    paddingVertical: 8,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    ...Platform.select({
      android: { position: 'absolute', paddingBottom: 0 },
      ios: { position: 'absolute', paddingBottom: 24 },
    }),
  },
  priceText: {
    color: colors.foxyBlack,
    fontSize: size.h2,
    fontFamily: 'Roboto-Medium',
  },
  priceTextNormal: {
    color: colors.foxyBlack,
    fontSize: size.h3,
    fontFamily: 'Roboto-Regular',
  },
  priceTextLineThrough: {
    color: colors.darkGrey,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
    textDecorationLine: 'line-through',
    marginLeft: 8,
  },
  extraPadding: {
    paddingVertical: 7,
  },
  priceFreeText: {
    color: Config.THEME_COLOR || colors.green,
    fontSize: size.h2,
    fontFamily: 'Roboto-Medium',
  },
  priceTextSubtitle: {
    color: colors.subtitle,
    fontSize: size.h3_5,
    fontFamily: 'Roboto-Regular',
  },
  secondaryButtonContainer: {
    width: getScreenWidth() * 0.5 - 16,
    alignItems: 'center',
    backgroundColor: Config.THEME_COLOR || colors.green,
    borderRadius: 6,
    paddingVertical: 2,
    height: 50,
  },
  primaryButtonContainer: {
    width: getScreenWidth() * 0.5 - 16,
    alignItems: 'center',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Config.THEME_COLOR || colors.green,
    borderStyle: 'solid',
    justifyContent: 'center',
    alignContent: 'center',
    paddingVertical: 4,
    height: 50,
  },
  primaryButtonFullWidthContainer: {
    width: getScreenWidth() - 24,
    alignItems: 'center',
    backgroundColor: Config.THEME_COLOR || colors.green,
    borderRadius: 6,
  },
  previewRoutineContainer: {
    width: getScreenWidth() * 0.5 - 16,
    alignItems: 'center',
    paddingVertical: 13,
    backgroundColor: colors.white,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Config.THEME_COLOR || colors.green,
  },
  subscriptionButtonDisabledContainer: {
    width: getScreenWidth() * 0.5 - 16,
    alignItems: 'center',
    paddingVertical: 4,
    backgroundColor: colors.darkGrey,
    borderRadius: 6,
    height: 50,
  },
  subscriptionButtonDisabledFullWidthContainer: {
    width: getScreenWidth() - 24,
    alignItems: 'center',
    paddingVertical: 4,
    backgroundColor: colors.darkGrey,
    borderRadius: 6,
    height: 50,
  },
  subscriptionButtonText: {
    color: colors.white,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
    alignSelf: 'center',
  },
  subscriptionClosedButtonText: {
    color: colors.white,
    fontSize: size.h2,
    fontFamily: 'Roboto-Medium',
    alignSelf: 'center',
  },
  verificationTitle: {
    color: colors.white,
    fontSize: size.h2,
    fontFamily: 'Roboto-Medium',
    alignSelf: 'center',
  },
  verificationSubText: {
    color: colors.white,
    fontSize: size.h4,
    fontFamily: 'Roboto-Medium',
    alignSelf: 'center',
  },
  subscritionClosedContainer: {
    width: getScreenWidth() - 24,
    backgroundColor: colors.disabled,
    borderRadius: 6,
    height: 50,
  },
  verificationPending: {
    width: getScreenWidth() * 0.5 - 16,
    backgroundColor: colors.disabled,
    borderRadius: 6,
    paddingVertical: 6,
  },
  startNowButtonText: {
    color: colors.white,
    fontSize: size.h1,
    fontFamily: 'Roboto-Medium',
    alignSelf: 'center',
    paddingVertical: 6,
  },
  previewButtonText: {
    color: Config.THEME_COLOR || colors.green,
    fontSize: size.h2,
    fontFamily: 'Roboto-Medium',
  },
  separater: {
    height: 12,
  },
  titlePlaceholder: {
    height: 28,
    width: '80%',
    alignSelf: 'center',
    marginBottom: 12,
  },
  productListsTitle: {
    color: Config.THEME_COLOR || colors.green,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h1,
    marginTop: 18,
  },
  productListsSubtitle: {
    color: colors.foxyBlack,
    fontFamily: 'Roboto-Regular',
    fontSize: size.h3,
    marginTop: 4,
  },
  productBanner: {
    resizeMode: 'contain',
    borderRadius: 4,
    height: 100,
    marginVertical: 12,
    ...Platform.select({
      web: {
        height: isDesktop() ? 200 : 100,
        resizeMode: '',
      },
      default: { flex: 1 },
    }),
  },
  emptyView: {
    height: 150,
  },
  primaryButtonText: {
    fontSize: size.h3,
    color: Config.THEME_COLOR || colors.green,
    alignSelf: 'center',
    textAlign: 'center',
  },
  primaryButtonStyle: {
    width: getScreenWidth() * 0.5 - 16,
    alignItems: 'center',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Config.THEME_COLOR || colors.green,
    borderStyle: 'solid',
    justifyContent: 'center',
    alignContent: 'center',
    paddingVertical: 4,
    height: 47,
  },
  actionIconStyle: {
    height: 24,
    width: 24,
    marginRight: 6,
  },
  secondaryButtonTextContainer: {
    color: colors.white,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
    textAlign: 'center',
  },
  primaryButtonTextContainer: {
    flexDirection: 'row',
  },
  image: { height: 35, width: 35, alignSelf: 'center' },
  primaryButtonContainerForFreeRoutine: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  textForFreeRoutine: {
    color: colors.darkGrey,
    fontSize: size.h4,
    fontFamily: 'Roboto-Medium',
    textAlign: 'center',
  },
  subTextForFreeRoutine: {
    color: colors.black,
    fontSize: size.h2,
    fontFamily: 'Roboto-Medium',
    textAlign: 'center',
  },
  JoinWhatsappButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: getScreenWidth() - 24,
    borderRadius: 6,
    borderWidth: 1,
    borderStyle: 'solid',
    alignContent: 'center',
    paddingVertical: 4,
    height: 50,
    backgroundColor: colors.black,
  },
  whatsappIcon: {
    height: 16,
    width: 16,
    tintColor: colors.white,
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  buttonText: {
    fontSize: size.h2,
    color: colors.white,
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Roboto-Medium',
    paddingHorizontal: 8,
  },
  activityIndicator: {
    paddingVertical: 9,
  },
  checkEligibilityText: {
    color: colors.white,
    fontSize: size.h1,
    fontFamily: 'Roboto-Medium',
    alignSelf: 'center',
    paddingVertical: 6,
  },
});